<div
  class="loading-overlay"
  *ngIf="isLoading$ | async"
  role="status"
  aria-live="polite"
  aria-label="Cargando datos"
>

  <div class="loading-card hs-loading-card" role="alert" aria-live="polite">
    <div class="hs-left">
      <div class="hs-avatar-wrap" aria-hidden="true">
        <div class="hs-avatar-ring"></div>
        <div class="avatar-bg hs-avatar-bg"
            [style.background-image]="safeBackground"
            role="img"
            aria-label="Avatar"></div>
        <div class="hs-avatar-glow" aria-hidden="true"></div>
      </div>
    </div>

    <div class="hs-right">
      <div class="hs-text">
        <div class="hs-title">Cargando datos...</div>
        <div class="hs-sub">Un momento, por favor.</div>

        <div class="hs-skeleton">
          <div class="hs-line short"></div>
          <div class="hs-line medium"></div>
          <div class="hs-line long"></div>
        </div>

        <div class="hs-activity">
          <div class="hs-dots" aria-hidden="true">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>